import { useI18nContext } from '@/i18n/i18n-react';
import { MetricCard } from './metric-card';
import { BarChart, Receipt, Bell, Banknote, Target } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { SalesChart } from './sales-chart';
import { HelpIconButton } from '@/components/help-panel/help-icon-button';

export function MockedMetrics() {
  const { LL, locale } = useI18nContext();

  return (
    <>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        <MetricCard
          title={LL.totalSales()}
          value={3473}
          icon={<BarChart className="h-6 w-6" />}
          description=""
          isLoading={false}
          helpKey="totalSales"
        />
        <MetricCard
          title={LL.metricsPage.revenue.title()}
          value={1284373.45}
          currency={'BRL'}
          icon={<Receipt className="h-6 w-6" />}
          description=""
          isLoading={false}
          helpKey="revenue"
        />
        <MetricCard
          title={LL.metricsPage.notificationConversion.title()}
          value={new Intl.NumberFormat(locale, {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(0.0125)}
          icon={<Bell className="h-6 w-6" />}
          description=""
          isLoading={false}
          helpKey="notificationConversion"
        />
        <MetricCard
          title={LL.metricsPage.averageCampaignRevenue.title()}
          value={3450.75}
          currency="BRL"
          icon={<Banknote className="h-6 w-6" />}
          description=""
          isLoading={false}
          helpKey="averageCampaignRevenue"
        />
        <MetricCard
          title={LL.metricsPage.averageCampaignEngagement.title()}
          value={LL.metricsPage.campaigns.table.accessesCount({
            count: new Intl.NumberFormat(locale).format(1446),
          })}
          icon={<Target className="h-6 w-6" />}
          description=""
          isLoading={false}
          helpKey="averageCampaignImpact"
        />
      </div>
      <div className="mt-8">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-1.5">
              <span>{LL.monthlySalesRevenue()}</span>
              <HelpIconButton helpKey="salesChart" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-col gap-4 w-full h-[400px]">
              <SalesChart
                currency={'BRL'}
                granularity={'day'}
                points={[
                  {
                    date: '2026-01-01',
                    count: 120,
                    grossRevenueUsd: 34500.75,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-02',
                    count: 115,
                    grossRevenueUsd: 33120.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-03',
                    count: 98,
                    grossRevenueUsd: 28224.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-04',
                    count: 92,
                    grossRevenueUsd: 26496.8,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-05',
                    count: 125,
                    grossRevenueUsd: 35937.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-06',
                    count: 130,
                    grossRevenueUsd: 37375.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-07',
                    count: 128,
                    grossRevenueUsd: 36800.25,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-08',
                    count: 122,
                    grossRevenueUsd: 35075.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-09',
                    count: 118,
                    grossRevenueUsd: 33925.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-10',
                    count: 105,
                    grossRevenueUsd: 30187.4,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-11',
                    count: 89,
                    grossRevenueUsd: 25582.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-12',
                    count: 135,
                    grossRevenueUsd: 38812.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-13',
                    count: 142,
                    grossRevenueUsd: 40825.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-14',
                    count: 138,
                    grossRevenueUsd: 39675.3,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-15',
                    count: 145,
                    grossRevenueUsd: 41687.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-16',
                    count: 150,
                    grossRevenueUsd: 43125.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-17',
                    count: 112,
                    grossRevenueUsd: 32200.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-18',
                    count: 95,
                    grossRevenueUsd: 27312.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-19',
                    count: 155,
                    grossRevenueUsd: 44562.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-20',
                    count: 162,
                    grossRevenueUsd: 46575.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-21',
                    count: 158,
                    grossRevenueUsd: 45425.2,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-22',
                    count: 160,
                    grossRevenueUsd: 46000.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-23',
                    count: 168,
                    grossRevenueUsd: 48300.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-24',
                    count: 120,
                    grossRevenueUsd: 34500.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-25',
                    count: 105,
                    grossRevenueUsd: 30187.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-26',
                    count: 175,
                    grossRevenueUsd: 50312.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-27',
                    count: 182,
                    grossRevenueUsd: 52325.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-28',
                    count: 180,
                    grossRevenueUsd: 51750.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-29',
                    count: 185,
                    grossRevenueUsd: 53187.5,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-30',
                    count: 192,
                    grossRevenueUsd: 55200.0,
                    webGrossRevenue: 0,
                  },
                  {
                    date: '2026-01-31',
                    count: 140,
                    grossRevenueUsd: 40250.0,
                    webGrossRevenue: 0,
                  },
                ]}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
